export const registration_ru = {
  title: "",
  description: "",
  progress_bar: "",
  sms_code: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: "",
    repeat_sms: ""
  },
  email: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  create_password: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  repeat_password: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },

  make_cabinet: "",
  anketa_start_message: "",
  anketa_start_button: ""
};
export const registration_kz = {
  title: "",
  description: "",
  progress_bar: "",
  sms_code: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: "",
    repeat_sms: ""
  },
  email: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  create_password: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },
  repeat_password: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  },

  make_cabinet: "",
  anketa_start_message: "",
  anketa_start_button: ""
};
